import React, { useContext } from 'react';
import { TrackingContext } from '../../TrackingContext';
import liteSitePreviewStyles from './liteSitePreview.scss';
import { Theme, ThemeFamily } from './ThemeCard';
import verticalStyles from './themeCard.scss';
import { DisplaySwatch } from './ThemeCardComponents/ThemeCardSwatch';

export interface ThemeInfoProps {
  themeFamily: ThemeFamily | null;
  thumbnailTheme?: Theme | null;
  onClick?: (themeId: number) => void;
  selected?: number | null;
  featured?: number | null;
  dashboard?: boolean | null;
  hideInvitationLink?: boolean | null;
}

const getMatchingInvitationsLink = (
  theme: Theme,
  track: (event: string, trackingData?: any) => void,
  featured: boolean
) => {
  const onClick = () => {
    track('Matching Invitation links', {
      source: featured ? 'preview rail' : 'theme rail',
      themeName: theme?.name,
      current: featured,
      page: 'preview',
      partnerName: theme?.themeDesigner?.companyName,
    });
  };

  return theme?.designerUrl ? (
    <a href={theme?.designerUrl} target="_blank" rel="noopener noreferrer">
      <span onClick={onClick}>See matching invitations</span>
    </a>
  ) : null;
};

const ThemeInfo: React.FC<ThemeInfoProps> = ({
  themeFamily,
  thumbnailTheme,
  onClick,
  selected = null,
  featured = null,
  hideInvitationLink = false,
}) => {
  const { track } = useContext(TrackingContext);
  const themeName = thumbnailTheme?.name || '';

  return (
    <div className={verticalStyles.themeInfo}>
      <div className={`${verticalStyles.themeName} ${liteSitePreviewStyles.themeName}`}>{themeName}</div>
      <DisplaySwatch themeFamily={themeFamily} onClick={onClick} selected={selected} currentTheme={featured} />
      {featured || !thumbnailTheme?.designerUrl || hideInvitationLink ? null : (
        <div className={verticalStyles.designerName}>{getMatchingInvitationsLink(thumbnailTheme, track, false)}</div>
      )}
    </div>
  );
};

export const ThemeInfoFullWidth: React.FC<ThemeInfoProps> = ({
  themeFamily,
  thumbnailTheme,
  onClick,
  selected = null,
  featured = null,
  hideInvitationLink = false,
}) => {
  const { track } = useContext(TrackingContext);
  const themeName = thumbnailTheme?.name || '';

  return (
    <div className={verticalStyles['themeInfoFull']}>
      <div className={`${verticalStyles['themeNameFull']}`}>{themeName}</div>
      <DisplaySwatch themeFamily={themeFamily} onClick={onClick} selected={selected} currentTheme={featured} />
      {featured || !thumbnailTheme?.designerUrl || hideInvitationLink ? null : (
        <div className={verticalStyles.designerName}>{getMatchingInvitationsLink(thumbnailTheme, track, false)}</div>
      )}
    </div>
  );
};

interface MatchingInvitationsProps {
  theme: Theme;
}

export const MatchingInvitations: React.FC<MatchingInvitationsProps> = ({ theme }) => {
  const { track } = useContext(TrackingContext);

  return theme?.designerUrl ? (
    <div className={verticalStyles.matchingInvites}>{getMatchingInvitationsLink(theme, track, true)}</div>
  ) : null;
};

export default ThemeInfo;
